import { motion } from "framer-motion";
import { useRef } from "react";
import { useInView } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`overline ${className}`}>{children}</span>
);

export const AnimatedHeading = ({ children, className = "", as: Tag = "h2" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  return (
    <Tag ref={ref} className={`heading-underline ${inView ? "in-view" : ""} ${className}`}>
      {children}
    </Tag>
  );
};
